/**
 * Created by areynolds2 on 3/14/2017.
 */
import React from 'react';
import ReactDOM from 'react-dom';
import AppxpressForum from './forum';
import gtn from '../GTNexus.Common';
import FefPageBuilder from '../GTNexus.FEF-Page-Builder';
import CurlWidget from './components/curl';
import AuthorizationTable from './components/AuthorizationTable';

class AppxpressDocument extends React.Component{
    constructor(props){
        super(props);
        this.isForumDocument = false;
    }

    componentWillMount(){}
    componentDidMount(){
        console.log('Mounted');
    }
    componentDidUpdate(prevProps , prevState){}
    componentWillReceiveProps(nextProps){}

    // Check for schema tag - if there - translate into kendo UI component
    processDom(div) {
        //only process div component onMount - on dismount, do nothing here
        if (div) {
            let $div = $(div);
            $(document).trigger('bind-events-to-axml-page');

            if ( $div.find('include-forum-table').length) {
                let table = $(div).find('include-forum-table').get(0);
                let topic = $(table).attr('topic');
                this.isForumDocument = true;
                ReactDOM.render(<AppxpressForum topic={topic}/>, table);
            }
            //If page is the Fef-Page-Builder page - run the FefPageBuilder init fn
            if ( $div.find('Fef-Page-Builder').length) {
                FefPageBuilder.ready();
            }
            if ( $div.find('Curl-Table').length) {
                var curlStatements = $(div).find('Curl-Table');
                curlStatements.each(function (_, curl) {
                    let template = $(curl).text();
                    ReactDOM.render(<CurlWidget template={template}/>, curl);
                })
            }
            if ( $div.find('Authorization-Table').length) {
                var curlStatements = $(div).find('Authorization-Table');
                curlStatements.each(function (_, auth_table) {
                    ReactDOM.render(<AuthorizationTable />, auth_table);
                })
            }
            //  Render soho-tabs
            if( $div.find('div[soho-tabs-component="true"]').length ) {
                try{
                    $('.tab-container').tabs();
                }catch(e) {
                    console.log('soho-tabs failed to build');
                    console.error(e);
                }
            }
            // Render the files widget tree views.
            gtn.ui.axml.renderFilesWidgets();
            // Add page to recently viewed cache
            window.lastViewedAutocomplete.addToRecentlyViewed();
            // The article has finished rendering. Fire the heightChange event so post-processing can start,
            // such as syncing the positions of the article sections, etc.

            //Allow for complete rendering
            setTimeout( () => {
                $(document).trigger('article:heightChange');
                //For forum axml pages - forum component handles hash because there are no sections
                if( ! this.isForumDocument ){
                    setTimeout(function () {
                        if( gtn.currentHash ){
                            location.hash = gtn.currentHash;
                            var hashObj = gtn.getHash();
                            if (hashObj.section) {
                                // Select the corresponding article section.
                                gtn.ui.axml.selectSectionByHash(hashObj.section);
                            }
                        }
                    }, 100);
                }
            }, 300 );
        }
    }

    render(){
        if( this.props.body && this.props.loaded ) {
            console.log('rendering');
            return (
                <div className="article-content">
                    <div dangerouslySetInnerHTML={ {__html: this.props.body} } ref={ (el) => { this.processDom(el); } }>
                    </div>
                </div>
            );
        } else{
            return (
                <div className="article-content">
                    <LoadingSpinner />
                </div>
            )
        }
    }
}

class SideBarHeader extends React.Component{
    constructor(props){
        super(props);
        this.state = { selected : props.selected };
    }
        //need to enable class-transform-properties
    // handleClick = () => {

    render(){
        let componentInfo = this.props.header;
        let headerClasses = "anchor";
        componentInfo.isArticle ? headerClasses += " for-article" : headerClasses += " for-section";
        componentInfo.isSelected ? headerClasses += " active" : "";
        return (
            <div onClick={this.props.click} className={headerClasses}>{componentInfo.text}</div>
        )
    }
}

class Sidebar extends React.Component{
    constructor(props){
        super(props);
        this.setSections = this.setSections.bind(this);
        this.state = { sections : [] };
        this.minSectionsToCreateSideBar = 2;
        this.handleAnchorClick = this.handleAnchorClick.bind(this);
    }

    componentWillMount(){
        this.setSections(this.props.body);
    }
    componentWillReceiveProps(nextProps){
        this.setSections(nextProps.body);
    }

    setSections( doc ){
        let $doc = $(doc);
        let headers = [];
        let $sections = $doc.find(' > document > article > section');
        let articleTitle = $doc.find(" > document > article > .article-title").text();
        headers.push( { text : articleTitle , isArticle : true } );
        let sectionTitle;
        $sections.each( function() {
            sectionTitle = $(this).find("> .section-title").text();
            headers.push( { text : sectionTitle } );
        });
        this.setState({ sections : headers });
    }

    handleAnchorClick(e){
        let sections = this.state.sections;
        let selectedHeaderText = $(e.target).text();
        for(let iter of sections){
            iter.isSelected = iter.text == selectedHeaderText
        }
        this.setState({
            sections : sections
        });
        //Set article hash for section
        if( $(e.target).is('.for-article') )
            gtn.setHash('section' , '');
        else
            gtn.setHash("section", gtn.ui.hyphenEncode( selectedHeaderText.toLowerCase() ));
    }

    render(){
        if( this.state.sections.length > this.minSectionsToCreateSideBar ){
            return (
                <div className="article-sidebar">
                    { this.state.sections.map((section , i) =>
                        <SideBarHeader click={this.handleAnchorClick} key={section.text.toString() + i } header={section} /> )
                    }
                </div>
            );
        } else{
            return (<div></div>);
        }
    }
}

const loading_spinner_delay = 150;
class LoadingSpinner extends React.Component{
    constructor(props){
        super(props);
        this.state = { show : false };
        this.waitFn = null;
    }
    componentWillMount() {
        this.waitFn = setTimeout(() => {
            this.setState({show : true })
        }, loading_spinner_delay);
    }
    componentWillUnmount(){
        clearTimeout( this.waitFn );
    }
    render() {
        if(this.state.show){
            return (
                <div className="busy-indicator-container blocked-ui">
                    <div className="busy-indicator active">
                        <div className="bar one"></div>
                        <div className="bar two"></div>
                        <div className="bar three"></div>
                        <div className="bar four"></div>
                        <div className="bar five"></div>
                    </div>
                    <span>{ this.props.msg }</span>
                </div>);
        } else{
            return ( <div/> );
        }
    }
}
LoadingSpinner.defaultProps = {
    msg : 'Loading...'
};

//TODO MOVE THIS
const doc_loading_threshold = 30000;
export default class Doc extends React.Component {
    constructor(props){
        super(props);
        this.state = { loaded: false , htmlDocumentString : null };
    }

    asyncLoadBlogXml(){
        this.setState({loaded : false } );
        $.ajax({
            type : 'GET',
            url : '/axml' + this.url ,
            cache: gtn.ajaxCache,
            dataType : 'html',
            success : (doc , _ , xhr) => {
                console.log('Doc Loaded');
                //If its a blog containing a blog definition - bootstrap the blog
                //  Adds a header and footer
                if( $(doc).find('blog-definition').length ){
                    doc = gtn.ui.bootstrapBlog( doc );
                }
                /*
                    Here - we are loading the whole content pages axml file
                    If the page is large - defined here by being over the threshold for document size,
                    then the page will have so many html nodes it will take a second to layout on the screen
                    So - we leave the loading spinner up until the html nodes are ready
                    If the page is under the threshold, the page will be ready immediately - so indicate to hide
                    the loading spinner right away
                 */
                if( xhr.getResponseHeader('axml-document-length') > doc_loading_threshold ){
                    console.log('wait');
                    this.setState({ htmlDocumentString : doc });
                    setTimeout(() => {
                        this.setState({loaded : true });
                    }, 50 )
                } else{
                    this.setState( { loaded : true , htmlDocumentString : doc });
                }

                window.scrollTo(0 , 0);
            },
            error : (xhr) => {
                let $error = $('<div/>').addClass('m-page-summary-errors');
                if( xhr.status == 404 ){
                    $error.text('Page does not exist - If you believe this is a mistake, please contact the Infor Nexus Evangelism team')
                } else{
                    $error.text('An error occurred - please contact the Infor Nexus Evangelism team for a quick fix! Thanks');
                }
                let wrap = $('<div>').append( $error ).html();
                this.setState({
                    loaded : true ,
                    htmlDocumentString : wrap
                });
            }
        })
    }

    componentWillReceiveProps(nextProps){
        if( this.url != nextProps.url ){
            this.url = nextProps.url;
            this.asyncLoadBlogXml();
        }
    }

    componentWillMount(){
        this.url = this.props.url;
        this.asyncLoadBlogXml();
    }

    render() {
        return (
            <div>
                <AppxpressDocument body={this.state.htmlDocumentString} loaded={this.state.loaded } />
                <Sidebar body={this.state.htmlDocumentString}/>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./public/javascripts/react/doc.js